module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-view"
  }, [_c('div', {
    staticClass: "zoom-buttons"
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.zoom(+1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.zoom(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])]), _vm._v(" "), _c('super-map', {
    attrs: {
      "width": _vm.width,
      "visible": _vm.mapVisible
    }
  }), _vm._v(" "), (_vm.xcplanner) ? _c('xc-planner', {
    attrs: {
      "width": _vm.width,
      "visible": _vm.mapVisible
    }
  }) : _vm._e(), _vm._v(" "), _c('left-menu'), _vm._v(" "), _c('search-box'), _vm._v(" "), (_vm.needAgreement) ? _c('accept-terms', {
    attrs: {
      "date": ""
    }
  }) : _c('notification'), _vm._v(" "), _c('altitude-control'), _vm._v(" "), _c('map-legend')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11965bd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/map-view.vue
// module id = 327
// module chunks = 1